export type SignInErrorCause =
  | "no_tokens_available"
  | "cancelled"
  | "network_fail"
  | "timeout"
  | "unknown";

export class SignInError extends Error {
  public cause: SignInErrorCause;

  constructor(message: string, cause: SignInErrorCause) {
    super(message);
    this.name = "SignInError";
    this.cause = cause;
  }
}
